var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inbox-message message-outbound",staticStyle:{"background":"#fffcdc"}},[_c('div',{staticClass:"message-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.note.content)}}),_vm._v(" "),_c('div',{staticStyle:{"opacity":".6"}},[_vm._v("Added by "+_vm._s(_vm.note.created_by.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }